import { ITASCA_SAVED_SELECTIONS_URL } from '@/constants/urls';
import { resolveV3 } from '@/endpoints/resolveV3';
import DataResponse from '@/endpoints/types';

type DeleteReportResponse = DataResponse<{}>;

interface IData {
  savedSelectionId: string | number;
  reportId: string | number;
}

export const deleteReportForSavedSelectionById = async (
  data: IData,
  signal?: AbortSignal
): Promise<DeleteReportResponse> =>
  resolveV3(
    {
      method: 'DELETE',
      signal,
      url: `${ITASCA_SAVED_SELECTIONS_URL}${data.savedSelectionId}/insights-reports/${data.reportId}/`,
    },
    {
      baseUrl: 'itasca',
    }
  );
